function coerceToDate(d: Date | string): Date {
	if (typeof d === 'string') {
		const parsed = new Date(d);
		if (isNaN(parsed.getTime())) {
			throw new Error(`Cannot convert ${d} to a new date`);
		}
		return parsed;
	}
	return d;
}

function pad2(n: number): string {
	return n < 10 ? `0${n}` : `${n}`;
}

/** Browser-local calendar day `YYYY-MM-DD` (legacy `CustomFunctions.dateToDateString`). */
export function formatMasLocalCalendarDate(d: Date | string): string {
	const date = coerceToDate(d);
	return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

/** Browser-local 24h time `HH:mm` (legacy `CustomFunctions.timeToDateString24`). */
export function formatMasLocalTime24(d: Date | string): string {
	const date = coerceToDate(d);
	return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

/** MAS local wall-clock `YYYY-MM-DDTHH:mm` (legacy `CustomFunctions.dateToUTCString`; not ISO UTC). */
export function formatMasLocalDateTime(d: Date | string): string {
	return `${formatMasLocalCalendarDate(d)}T${formatMasLocalTime24(d)}`;
}

/** Local calendar midnight as MAS datetime string (legacy `CustomFunctions.midnight`). */
export function formatMasLocalMidnight(daysOffset = 0): string {
	const tzoffset = new Date().getTimezoneOffset() * 60000;
	const msOffset = daysOffset * 24 * 60 * 60000;

	const d = new Date(Date.now() - tzoffset + msOffset).toISOString().slice(0, -1);

	const date = new Date(d);

	const dayAsInt = date.setDate(date.getDate());
	const givenDate = new Date(dayAsInt);
	const day = `0${givenDate.getDate()}`;
	const month = `0${givenDate.getMonth() + 1}`;
	const year = `${givenDate.getFullYear()}`;

	return `${year}-${month.substr(-2)}-${day.substr(-2)}T00:00:00`;
}
